import { useMutation } from 'react-query';
import {
  createSevenEduIntegrationAsync,
  deleteSevenEduIntegrationAsync,
  getAllSevenEduIntegrationsAsync,
  getSevenEduIntegrationByIdAsync,
  updateSevenEduIntegrationAsync,
} from '../../index';

export const useCreateSevenEduIntegrationAsync = () =>
  useMutation(createSevenEduIntegrationAsync);

export const useGetSevenEduIntegrationByIdAsync = () =>
  useMutation(getSevenEduIntegrationByIdAsync);

export const useGetAllSevenEduIntegrationsAsync = () =>
  useMutation(getAllSevenEduIntegrationsAsync);

export const useUpdateSevenEduIntegrationAsync = () =>
  useMutation(updateSevenEduIntegrationAsync);

export const useDeleteSevenEduIntegrationAsync = () =>
  useMutation(deleteSevenEduIntegrationAsync);
